import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BounceLoader } from 'react-spinners';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Button from '../../common/components/Button';
import { getCopy } from '../../common/lib/copyDefaults';
import { verifyEmail } from '../../redux/actions';

import '../../../style/index.css';
import './verifyEmail.css';

const mapStateToProps = (state) => ({
  errorDetail: state.verifyEmailReducer.errorDetail,
  emailVerificationFailed: state.verifyEmailReducer.emailVerificationFailed,
  emailVerificationSuccess: state.verifyEmailReducer.emailVerificationSuccess,
  statusCode: state.verifyEmailReducer.statusCode,
  isVerifying: state.verifyEmailReducer.isVerifying,
  isEmailVerified: state.verifyEmailReducer.isEmailVerified,
});

const mapDispatchToProps = { verifyEmail };

class VerifyEmailView extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    verifyEmail: PropTypes.func.isRequired,
    isVerifying: PropTypes.bool.isRequired,
    emailVerificationSuccess: PropTypes.bool.isRequired,
    emailVerificationFailed: PropTypes.bool.isRequired,
    errorDetail: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  };

  constructor(props) {
    super(props);
    this.handleContinueClick = this.handleContinueClick.bind(this);
  }

  componentDidMount() {
    this.props.verifyEmail();
  }

  componentDidUpdate(prevProps) {
    const { emailVerificationSuccess, emailVerificationFailed } = this.props;
    if (
      (emailVerificationSuccess && !prevProps.emailVerificationSuccess) ||
      (emailVerificationFailed && !prevProps.emailVerificationFailed)
    ) {
      requestAnimationFrame(() => {
        const el = document.getElementById('verify-email-heading');
        if (el) {
          el.focus();
        }
      });
    }
  }

  handleContinueClick(e) {
    e.preventDefault();
    this.props.history.push('/complete-registration');
  }

  render() {
    const {
      isVerifying,
      emailVerificationSuccess,
      emailVerificationFailed,
      errorDetail,
    } = this.props;
    const copy = getCopy('/verify-email');

    return (
      <div className="verify-email row justify-content-center">
        <div className="col-xl-7 col-lg-8 col-md-8 col-sm-10">
          {isVerifying && (
            <div className="loading-wrapper">
              <BounceLoader color="#084267" />
            </div>
          )}
          {!isVerifying && emailVerificationSuccess && (
            <>
              <div className="verify-email__body">
                <h1
                  id="verify-email-heading"
                  tabIndex={-1}
                  className="verify-email__title"
                >
                  {copy.header}
                </h1>
                <p className="verify-email__description">{copy.body}</p>
                <p className="verify-email__description">{copy.line2}</p>
              </div>
              <div className="button-wrap">
                <Button
                  label={copy.continueLabel}
                  onClickFn={this.handleContinueClick}
                  className="nyl-button"
                  id="verify-email-continue-button"
                />
              </div>
            </>
          )}
          {!isVerifying && emailVerificationFailed && (
            <div className="verify-email__body">
              <h1
                id="verify-email-heading"
                tabIndex={-1}
                className="verify-email__title verify-email__title--error"
              >
                Verification failed
              </h1>
              <p className="verify-email__description">
                {errorDetail || copy.failureMessage}
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VerifyEmailView));
